import { BackgroundSt, FullImageSt, ImageSt } from './ImageSlide.css';
import { ReactElement, Ref } from 'react';

interface IImageSlideProps {
  withBackground?: boolean;
  alt?: string;
  sliderContainer?: Ref<HTMLDivElement>;
  src?: string;
  srcSet?: string;
}

const ImageSlide = ({
  alt,
  sliderContainer,
  src,
  srcSet,
  withBackground = false,
}: IImageSlideProps): ReactElement => (
  <>
    {!withBackground ? (
      <FullImageSt
        src={src}
        srcSet={srcSet}
        alt={alt}
        defaultSrc="/assets/images/default-car-placeholder.png"
        rootRef={sliderContainer}
        lazy
      />
    ) : (
      <>
        <BackgroundSt
          src={src}
          srcSet={srcSet}
          rootRef={sliderContainer}
          alt={`${alt}-bg`}
          defaultSrc="/assets/images/default-car-placeholder.png"
          lazy
        />
        <ImageSt
          src={src}
          srcSet={srcSet}
          alt={alt}
          defaultSrc="/assets/images/default-car-placeholder.png"
          lazy
          rootRef={sliderContainer}
          withBackground
        />
      </>
    )}
  </>
);

export default ImageSlide;
